export enum ErknmApproveRemarkSectionCodeEnum {
  KIND_KNM = 'KIND_KNM',
  DATES = 'DATES',
  REASONS = 'REASONS',
  OBJECTS = 'OBJECTS',
  EXPERTS = 'EXPERTS',
  COLLABORATING_ORGANIZATIONS = 'COLLABORATING_ORGANIZATIONS',
  EVENTS = 'EVENTS',
  REQUIREMENTS = 'REQUIREMENTS',
  CHECKLISTS = 'CHECKLISTS',
  PLACES = 'PLACES',
  APPROVE_DOCS = 'APPROVE_DOCS',
}
